import { render, staticRenderFns } from "./ATasteOfAutumn.vue?vue&type=template&id=2c0a83eb&scoped=true"
import script from "./ATasteOfAutumn.vue?vue&type=script&lang=js"
export * from "./ATasteOfAutumn.vue?vue&type=script&lang=js"
import style0 from "./ATasteOfAutumn.vue?vue&type=style&index=0&id=2c0a83eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a83eb",
  null
  
)

export default component.exports